// extracted by mini-css-extract-plugin
export default {"bar":"Slider_bar__jyY-q","dragging":"Slider_dragging__jylSD","touchTarget":"Slider_touchTarget__xwiS2","dot":"Slider_dot__JMUah"};